import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axiosInstance from "../../interceptor/axiosInstance";


const ValidateEmail = () => {
  const [searchParams] = useSearchParams();  // Hook to read query parameters
  const [status, setStatus] = useState('Validating...');
  const [isValid, setIsValid] = useState(null);  // To track if the validation is successful or not
  const navigate = useNavigate();

  useEffect(() => {
    const validateEmailRequest = async () => {
      try {
        const code = searchParams.get('code');  // Retrieve the validation code from the query string

        if (!code) {
          setStatus('Invalid or missing validation code');
          setIsValid(false);
          return;
        }

        // Send code to backend to validate email
        const response = await axiosInstance.get(`/auth/validate-email?code=${code}`);
        setStatus(response.data.message);  // Show success message if validation is successful
        setIsValid(true);
      } catch (error) {
        setStatus(error.response?.data?.message || 'Failed to validate email');
        setIsValid(false);
      }
    };

    validateEmailRequest();
  }, [searchParams]);

  useEffect(() => {
    if (isValid === true) {
      setTimeout(() => {
        navigate('/validate-email-success');  // Redirect to success page
      }, 100);
    }

    if (isValid === false) {
      setTimeout(() => {
        navigate('/validate-email-failure');  // Redirect to failure page
      }, 100);
    }
  }, [isValid, navigate]);

  return (
    <div>
      <h2>Email Validation</h2>
      <p>{status}</p>
    </div>
  );
};

export default ValidateEmail;
